export default __webpack_public_path__ + "static/media/cake-logo-horizontal.965bdc06.svg";